import * as React from "react";
import {WithStyles, withStyles} from "@material-ui/core/styles";
import {Check} from "@material-ui/icons";
import clsx from "clsx";
import {IFamilyMember} from "@app-types/websocket/family.types";
import {ITodo} from "@app-types/websocket/todo.types";
import Button from "@components/common/button/Button";
import IconButton from "@components/common/iconButton/iconButton.component";
import ImgAvatar from "@components/common/avatar/ImgAvatar";
import EditTodoDialog from "@components/todo/EditTodoDialog";
import {useTodoSeen} from "@components/todo/useTodoSeen";
import TranslateNew from "@translate/TranslateNew";
import {styleColors} from "src/main.style";
import {PackingListItemStyle as styles} from "./PackingListItem.style";

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof styles> {
  todo: ITodo;
  family: IFamilyMember[];
  myAccountId: number;
  scheduleParents: number[];
  scheduleChildren: number[];
  active: boolean;
  complete: (completed: boolean) => void;
  seen: () => void;
}

const PackingListItem = (props: IProps) => {
  const {classes, todo, family} = props;
  const row = React.useRef<HTMLDivElement | null>(null);
  const [editing, setEditing] = React.useState(false);
  const seen = !!todo.seen && todo.seen.indexOf(props.myAccountId) > -1;
  const {recentlySeen} = useTodoSeen(row, {
    todo, myAccountId: props.myAccountId, active: props.active && !editing, seen, onSeen: props.seen,
  });
  const completed = !!todo.completedBy;
  const assignees = (todo.assigned || []).map(id => family.find(member => member.id === id))
    .filter((member): member is IFamilyMember => member !== undefined);

  return (
    <>
      <div ref={row} data-todo-id={todo.id}
        data-read-state={seen ? (recentlySeen ? 'just-seen' : 'seen') : 'unseen'}
        className={clsx(classes.row, !seen && classes.unseen, recentlySeen && classes.recentlySeen)}>
        <Button type="button" classes={{root: classes.details, label: classes.detailsLabel}}
          onClick={() => setEditing(true)} aria-label={`${tn.lang.edit}: ${todo.title}`}>
          {assignees.length > 0 && (
            <span className={classes.avatars} style={{opacity: completed ? 0.5 : 1}}>
              {assignees.map((member, index) => (
                <ImgAvatar key={member.id} altText={member.firstName} color={member.color || '#FFFFFF'}
                  imgName={member.avatar} imgUrl={member.imageAvatar ? member.avatarURL : undefined}
                  style={{width: 22, height: 22, marginLeft: index > 0 ? -9 : 0,
                    border: `1px solid ${styleColors.white}`, boxSizing: 'border-box'}} />
              ))}
            </span>
          )}
          <span className={classes.body}>
            <span className={clsx(classes.title, completed && classes.completedTitle)}>{todo.title}</span>
            {todo.description && <span className={classes.description}>{todo.description}</span>}
          </span>
        </Button>
        <IconButton onClick={() => props.complete(!completed)}
          classes={{root: clsx(classes.checkButtonRoot, completed && classes.checkButtonChecked)}}
          aria-pressed={completed}
          aria-label={completed ? tn.lang.todoMarkIncomplete(todo.title) : tn.lang.todoMarkComplete(todo.title)}>
          <Check fontSize="small" color="inherit" style={{width: 20, height: 20}} />
        </IconButton>
      </div>
      <EditTodoDialog open={editing} close={() => setEditing(false)} todo={todo}
        scheduleParents={props.scheduleParents} scheduleChildren={props.scheduleChildren} />
    </>
  );
};

export default withStyles(styles)(PackingListItem);



// WEBPACK FOOTER //
// ./src/components/next-handover/PackingListItem.tsx